'use strict';
import { observable, action } from 'mobx';
import { fetch, buildUrl } from '@/lib/fetchAPI';

class DeviceInfoDetailStore {
  @observable deviceDetail = {};
  @observable form = null;
  @observable deviceLoading = false;

  @action
  loadDeviceDetail(deviceId) {
    this.deviceLoading = true;
    this.deviceDetail = {};
    fetch(
      `/api/device/info${buildUrl({ device_id: deviceId })}`,
      { method: 'GET' },
      json => {
        this.deviceDetail = { ...json };
        this.deviceLoading = false;
        if (this.form) {
          this.form.setFieldsValue({ remark: this.deviceDetail.memo || '' });
        }
      }
    );
  }

  postDeviceMemo(memo, deviceId) {
    return fetch(
      `/api/device/memo${buildUrl({ device_id: deviceId, memo: memo })}`,
      { method: 'POST' },
      json => json
    );
  }
}
export default new DeviceInfoDetailStore();



// WEBPACK FOOTER //
// ./src/store/DeviceInfo/DeviceDetail.js